import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Banner.css';
// import bgImage from './images/displaypic2.jpg';
const Banner = ({ 
  title = "Shop at Kajja Galleries",
  subtitle = "Explore our curated collection of premium home decor",
  primaryBtnText = "ORDER NOW",
  secondaryBtnText = "Learn More",
  variant = "default", // 'default', 'minimal', 'bold', 'dark'
  parallax = true,
  imageUrl = "./images/displaypic2.JPG"
}) => {
  const [scrollY, setScrollY] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const nav =useNavigate()

  const goToShop =()=>{
      nav('/shop')
  }

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    if (parallax) {
      window.addEventListener('scroll', handleScroll);
    }

    // Simulate loading for demo purposes
    const timer = setTimeout(() => setLoaded(true), 300);

    return () => {
      if (parallax) window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, [parallax]);

  const parallaxStyle = parallax ? {
    transform: `translateY(${scrollY * 0.3}px)`
  } : {};

  const getVariantClass = () => {
    switch(variant) {
      case 'minimal': return 'banner-minimal';
      case 'bold': return 'banner-bold';
      case 'dark': return 'banner-dark';
      default: return '';
    }
  };

  return (
    <div className={`banner-container ${getVariantClass()} ${loaded ? 'loaded' : ''}`}>
      <div className="banner-background" style={{ backgroundImage: `url(${imageUrl})` }}>
        <div className="banner-parallax-layer" style={parallaxStyle}></div>
      </div>
      
      <div className="banner-overlay"></div>
      
      <div className="banner-content">
        <h1 className="banner-title" data-aos="fade-up">
          {title}
        </h1>
        <p className="banner-subtitle" data-aos="fade-up" data-aos-delay="100">
          {subtitle}
        </p>
        
        <div className="banner-actions" data-aos="fade-up" data-aos-delay="200">
          <button onClick={goToShop} className="banner-btn primary">
            {primaryBtnText}
          </button>
          {secondaryBtnText && (
            <button onClick={goToShop} className="banner-btn secondary">
              {secondaryBtnText}
            </button>
          )}
        </div>
      </div>
      
      <div className="banner-scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </div>
  );
};

export default Banner;